import { createSlice } from '@reduxjs/toolkit';

import {
  AUTH_REDUCER,
  AuthInfo,
  loginAction,
  logoutAction,
  setAuthInfoAction
} from 'store/auth/auth.actions';
import { AUTH_TOKEN, REFRESH_TOKEN, getFromLocalStorage } from 'utils/localStorage';

const initialState: Partial<AuthInfo> = {
  token: getFromLocalStorage(AUTH_TOKEN),
  refreshToken: getFromLocalStorage(REFRESH_TOKEN),
};

export const authSlice = createSlice({
  name: AUTH_REDUCER,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loginAction.resolved, (state, {payload}) => {
        state.token = payload.token
        state.refreshToken = payload.refreshToken
      })
      .addCase(setAuthInfoAction, (state, {payload}) => {
        state.token = payload.token
        state.refreshToken = payload.refreshToken
      })
      .addCase(logoutAction, (state) => {
        state.token = undefined
        state.refreshToken = undefined
      })
  }
});

export default authSlice.reducer;
